import spacing from 'theme/config/spacing'

export default {
  container: {
    padding: spacing(1)
  },
};
